module.exports = __webpack_public_path__ + "static/media/chart_icon.ff17bc5b.svg";